module.exports = __webpack_public_path__ + "img/sumbox_img.ac3b50ee.png";